import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from "../hooks/useAuth"

const date = new Date()
const today = new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'short' }).format(date)

const DashFooter = () => {

    const { username, status } = useAuth()

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const onGoHomeClicked = () => navigate('/dash')

    let goHomeButton = null
    if (pathname !== '/dash') {
        goHomeButton = (
            <button
                className="text-2xl"
                title="Home"
                onClick={onGoHomeClicked}
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5" />
                    </svg> Home
            </button>
        )
    }

    const content = (
        <footer className="text-[12px] p-4 items-center flex justify-between text-white absolute bottom-0 w-full bg-[#151a26] border-t-2 border-gray-600">
            <div>

                {goHomeButton}
            </div>
            <div className='mx-6'>
                <p>Log In as {status}</p>
                <p>Current User: {username}</p>
                {today}
                <hr className='border-[#FFF] w-7 mb-5' />
            </div>
        </footer>
    )
    return content
}
export default DashFooter